<template>
  <v-container fluid>
    <div v-if="loading">
      <div class="mb-3">
        <v-skeleton-loader type="list-item-two-line"></v-skeleton-loader>
      </div>
      <div>
        <v-skeleton-loader type="table"></v-skeleton-loader>
      </div>
    </div>
    <div v-else>
      <v-row align="center" no-gutters justify="space-between">
        <div class="text-h1 mb-4">
          Status dos Inversores
        </div>
        <div class="filtros">
          <v-row no-gutters align="center" justify="end">
            <div class="py-2 px-2">
              <v-row no-gutters>
                <v-form @submit.prevent="buscaItens()">
                  <v-text-field
                    clearable
                    hide-details=""
                    clear-icon="close"
                    v-model="search"
                    outlined
                    label="Busca"
                    @click:clear="limparBusca()"
                  ></v-text-field>
                </v-form>
                <v-autocomplete
                  v-if="nivelUsuarioApelido === 'M'"
                  :menu-props="{ offsetY: true}"
                  class="ml-3"
                  :items="distribuidores"
                  label="Distribuidor"
                  append-icon="expand_more"
                  v-model="distribuidor"
                  hide-details=""
                  :loading="loading || loadingDistribuidores"
                  :disabled="loading || loadingDistribuidores"
                  outlined
                  @click:clear="() => {
                    this.options.page = 1
                    this.applyFilter()
                  }"
                  clearable
                  clear-icon="close"
                  @change="applyFilter()"
                ></v-autocomplete>
                <v-autocomplete
                  v-if="nivelUsuarioApelido === 'M' || nivelUsuarioApelido === 'D'"
                  :menu-props="{ offsetY: true}"
                  class="ml-3"
                  :items="integradores"
                  label="Integrador"
                  append-icon="expand_more"
                  v-model="integrador"
                  hide-details=""
                  :loading="loading || loadingIntegradores"
                  :disabled="loading || loadingIntegradores"
                  outlined
                  @click:clear="() => {
                    this.options.page = 1
                    this.applyFilter()
                  }"
                  clearable
                  clear-icon="close"
                  @change="applyFilter()"
                ></v-autocomplete>
              </v-row>
            </div>
            <div class="ml-3 cursor-pointer" v-for="(item, index) in statusItens" :key="index" @click="setStatus(item, index)">
              <v-btn
                :dark="item.elevation"
                :outlined="!item.elevation"
                :class="
                  item.text === 'Online' && item.elevation ? 'bg-green' :
                  item.text === 'Online' && !item.elevation ? 'text-green' :
                  item.text === 'Offline' && item.elevation ? 'bg-red' :
                  item.text === 'Offline' && !item.elevation ? 'text-red' :
                  item.text === 'Alerta' && item.elevation ? 'bg-primary' :
                  item.text === 'Alerta' && !item.elevation ? 'text-primary' :
                  item.text === 'Não definido' && item.elevation ? 'bg-yellow' :
                  item.text === 'Não definido' && !item.elevation ? 'text-yellow' :
                  item.text === 'Sem conexão' && item.elevation ? 'bg-blue' :
                  item.text === 'Sem conexão' && !item.elevation ? 'text-blue' :
                  item.text === 'Sem retorno' && item.elevation ? 'bg-gray' : 'text-gray'
                  "
                >
                {{item.text}}
              </v-btn>
            </div>
          </v-row>
        </div>
      </v-row>
      <v-data-table
        :headers="headers"
        :items="dados"
        :search="search"
        :server-items-length="total"
        :options.sync="options"
        loading-text="Carregando... Por favor aguarde"
        disable-sort
        :loading="carregando"
        class="elevation-1 base_table"
        :footer-props="{
          itemsPerPageOptions: [5,10,15,20,25,50,100],
          showFirstLastPage: true,
          firstIcon: 'skip_previous',
          lastIcon: 'skip_next',
          prevIcon: 'chevron_left',
          nextIcon: 'chevron_right'
        }"
        :header-props="{
          sortIcon: 'north',
        }"
      >
        <template v-slot:item.producao_inversor_hoje="{ item }">
          <v-row no-gutters align="center" justify="center">
            <v-col>
              {{calcProduction(item.producao_inversor, 'DAY')}}
            </v-col>
          </v-row>
        </template>
        <template v-slot:item.status.uss_nome="{ item }">
          <v-row no-gutters align="center" justify="center">
            <v-col>
              {{ item.status && item.status.uss_nome ? item.status.uss_nome : '-'}}
            </v-col>
          </v-row>
        </template>
        <template v-slot:item.producao_inversor_mes="{ item }">
          <v-row no-gutters align="center" justify="center">
            <v-col>
              {{calcProduction(item.producao_inversor, 'MONTH')}}
            </v-col>
          </v-row>
        </template>
        <template v-slot:item.producao_inversor_ano="{ item }">
          <v-row no-gutters align="center" justify="center">
            <v-col>
              {{calcProduction(item.producao_inversor, 'YEAR')}}
            </v-col>
          </v-row>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-row no-gutters align="center" justify="center">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }" v-if="item.status && item.status.uss_id == 3">
                <v-icon class="mr-3" color="warning" @click="openAlertDialog(item)">warning_amber</v-icon>
              </template>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon :color="$vuetify.theme.dark ? 'white' : 'black'" @click="openUsina(item.usina_inversor.usina)" >visibility</v-icon>
              </template>
              <span>Usina</span>
            </v-tooltip>
          </v-row>
        </template>
      </v-data-table>
      <v-dialog
        v-model="dialogAlerts"
        persistent
        max-width="400px"
      >
        <v-card class="ui-dialog-top">
          <v-row align="center" justify="space-between">
            <v-col cols="10">
              Alertas do inversor {{inversor.inv_serial}}
            </v-col>
            <v-col cols="2" class="text-right">
              <v-icon @click="closeAlertDialog()">close</v-icon>
            </v-col>
          </v-row>
        </v-card>
        <v-card class="ui-dialog-content">
          <v-list v-if="inversorAlarmes && !loadingAlerts">
            <v-list-item two-line>
              <v-list-item-content>
                <v-list-item-subtitle>
                  {{inversorAlarmes}}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <div v-if="!inversorAlarmes && !loadingAlerts">
            Não foi possível sincronizar os alertas deste Inversor
          </div>
        </v-card>
      </v-dialog>
    </div>
  </v-container>
</template>

<script>
import Api from '@API'
import moment from 'moment'
export default {
  data () {
    return {
      loading: false,
      loadingAlerts: false,
      total: 0,
      carregando: false,
      options: {},
      search: '',
      headers: [
        {
          text: 'ID',
          align: 'start',
          value: 'inv_id'
        },
        { text: 'Usina', value: 'usina_inversor.usina.usi_nome' },
        { text: 'Marca', value: 'inv_marca' },
        { text: 'Modelo', value: 'inv_modelo', align: 'center' },
        { text: 'Serial', value: 'inv_serial', align: 'center' },
        { text: 'Status', value: 'status.uss_nome' },
        { text: 'Produção hoje', value: 'producao_inversor_hoje', align: 'center' },
        { text: 'Produção mês', value: 'producao_inversor_mes', align: 'center' },
        { text: 'Produção ano', value: 'producao_inversor_ano', align: 'center' },
        {
          text: 'Ações',
          value: 'actions',
          align: 'center',
          sortable: false,
          width: 110
        }
      ],
      dados: [],
      integrador: '',
      integradores: [],
      loadingIntegradores: false,
      status: [],
      loadingStatus: false,
      distribuidor: '',
      distribuidores: [],
      loadingDistribuidores: false,
      interfacesSelect: [
        {
          text: 'SolarMaker',
          value: 1
        },
        {
          text: 'Renac',
          value: 2
        },
        {
          text: 'SolarMan',
          value: 3
        }
      ],
      dialogAlerts: false,
      inversor: {
        inv_serial: ''
      },
      inversorAlarmes: '',
      statusItens: [],
      selectedStatus: null
    }
  },
  watch: {
    options: {
      handler () {
        this.getInversores()
      },
      deep: true
    }
  },
  methods: {
    loadContent () {
      let filters = this.$route.query
      if (filters.distribuidor) this.distribuidor = filters.distribuidor
      if (filters.integrador) this.integrador = filters.integrador
      if (filters.busca) {
        this.search = filters.busca
        this.searchFinal = filters.busca
      }
      this.loadFunctions()
    },
    applyFilter () {
      if (this.distribuidorAnterior && this.distribuidor !== this.distribuidorAnterior) {
        this.integrador = ''
      }

      let query = Object.assign({},
        this.page ? { page: this.page } : '',
        this.distribuidor ? { distribuidor: this.distribuidor } : '',
        this.integrador ? { integrador: this.integrador } : '',
        this.searchFinal ? { busca: this.searchFinal } : '',
        this.selectedStatus ? { status: this.selectedStatus } : ''
      )

      this.$router.replace({name: 'StatusInversores', query: query}).catch(() => {})
      this.dados = []
      this.distribuidorAnterior = this.distribuidor
      this.getIntegradores(this.distribuidor)
      this.getInversores()
    },
    buscaItens () {
      this.searchFinal = this.search
      this.options.page = 1
      this.applyFilter()
    },
    limparBusca () {
      this.search = null
      this.searchFinal = null
      this.options.page = 1
      this.applyFilter()
    },
    async loadFunctions () {
      let filters = this.$route.query
      if (filters.distribuidor) this.distribuidor = filters.distribuidor
      if (filters.integrador) this.integrador = filters.integrador
      if (filters.page) this.page = Number(filters.page)

      await this.getStatus()
      if (filters.status) {
        this.selectedStatus = filters.status
        this.statusItens.map(status => {
          if (status.value === this.selectedStatus) {
            status.elevation = true
          }
        })
      }

      this.getInversores()
      this.getIntegradores()
      this.getDistribuidores()
    },
    async getDistribuidores () {
      this.loadingDistribuidores = true
      await Api.get('distribuidores')
        .then(res => {
          var arrayDists = []
          res.data.map(dist => {
            arrayDists.push({
              'text': dist.dis_nome,
              'value': dist.uuid_dis_id
            })
          })
          this.distribuidores = arrayDists
          this.loadingDistribuidores = false
        })
        .catch(err => {
          this.loadingDistribuidores = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os distribuidores!',
            color: 'error'
          })
          console.log(err)
        })
    },
    async getInversores () {
      this.carregando = true
      this.dados = []
      this.total = 0
      const { page, itemsPerPage } = this.options
      let pagina = 1
      let itensPagina = 10
      if (page) {
        pagina = page
      }
      if (itemsPerPage) {
        itensPagina = itemsPerPage
      }
      let filtro = '&filtro='
      if (this.distribuidor) {
        filtro += '&distribuidor=' + this.distribuidor
      }
      if (this.integrador) {
        filtro += '&integrador=' + this.integrador
      }
      if (this.searchFinal) {
        filtro += '&busca=' + this.searchFinal
      }
      if (this.selectedStatus) {
        filtro += '&status=' + this.selectedStatus
      }
      await Api.get(`inversores?page=${pagina}&per_page=${itensPagina}${filtro}`)
        .then(res => {
          let cha = []
          if (res.data.data.length) {
            res.data.data.map(item => {
              item.inv_garantia = item.inv_garantia ? moment(item.inv_garantia).format('DD/MM/YYYY') : ''
            })
            cha = res.data.data
          }
          this.dados = cha
          this.total = res.data.total
          this.carregando = false
        })
        .catch(err => {
          this.carregando = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os inversores!',
            color: 'error'
          })
          console.log(err)
        })
    },
    async getIntegradores (distribuidor = null) {
      this.loadingIntegradores = true
      let url = 'integradores'

      if (distribuidor) {
        url = `integradores/distribuidor/${distribuidor}`
      }

      await Api.get(url)
        .then(res => {
          var arrayInt = []
          res.data.map(int => {
            arrayInt.push({
              'text': int.int_nome,
              'value': int.uuid_int_id
            })
          })
          this.integradores = arrayInt
          this.loadingIntegradores = false
        })
        .catch(err => {
          this.loadingIntegradores = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os integradores!',
            color: 'error'
          })
          console.log(err)
        })
    },
    getAlertaDescricao (codes) {
      this.loadingAlerts = true
      Api.get(`inversor-alarm/${codes}`)
        .then((response) => {
          this.inversorAlarmes = ''
          response.data.forEach((alerta, index) => {
            if (index === 0) {
              this.inversorAlarmes += alerta.inv_al_descricao
            } else {
              this.inversorAlarmes += `, ${alerta.inv_al_descricao}`
            }
          })
          this.loadingAlerts = false
        })
        .catch((error) => {
          console.log(error.response)
          this.loadingAlerts = false
          this.$root.SnackControl.open(this, {
            text: error.response ? error.response.data.message : 'Ops! Ocorreu um erro ao carregar alertas!',
            color: 'error'
          })
        })
    },
    async getStatus () {
      this.loadingStatus = true
      await Api.get('usinas-status')
        .then(res => {
          var arrayUsi = []
          res.data.map(usi => {
            arrayUsi.push({
              'text': usi.uss_nome,
              'value': usi.uuid_uss_id
            })
          })
          this.statusItens = arrayUsi
          this.loadingStatus = false
        })
        .catch(err => {
          this.loadingUsinas = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os status!',
            color: 'error'
          })
          console.log(err)
        })
    },
    setStatus (item, index) {
      if (this.selectedStatus && this.selectedStatus === item.value) {
        this.selectedStatus = null
        this.statusItens[index].elevation = false
      } else {
        this.statusItens.map(status => {
          if (status.value !== item.value) {
            status.elevation = false
          }
        })
        this.selectedStatus = item.value
        this.statusItens[index].elevation = true
      }
      this.page = 1
      this.applyFilter()
    },
    updateData () {
      if (JSON.parse(localStorage.getItem('user')) !== null && !this.user) {
        this.user = JSON.parse(localStorage.getItem('user'))
        if (this.user.fk_gru_id_grupo) {
          this.nivelUsuarioApelido = 'M'
        }
        if (this.user.fk_dis_id_distribuidor) {
          this.nivelUsuarioApelido = 'D'
        }
        if (this.user.fk_int_id_integrador) {
          this.nivelUsuarioApelido = 'I'
        }
      }
    },
    openUsina (item) {
      this.$router.push({ name: 'VisaoGeralInterna', params: { uuid: item.uuid_usi_id } }).catch(() => {})
    },
    openAlertDialog (item) {
      this.inversor = item
      this.dialogAlerts = true

      this.getAlertaDescricao(this.inversor.alarmes[this.inversor.alarmes.length - 1].inv_al_his_alarmes)
    },
    closeAlertDialog () {
      this.inversor = {
        inv_serial: ''
      }
      this.inversorAlarmes = ''

      this.dialogAlerts = false
    },
    calcProduction (producao, period) {
      if (!producao.length) {
        return '-'
      }

      const setResult = (result) => {
        if (result > 1000) {
          return (result / 1000).toFixed(1) + ' MWh'
        }

        return result.toFixed(1) + ' kWh'
      }

      if (period === 'DAY') {
        let result = 0
        producao
          .filter(prod => prod.upr_data === moment().format('YYYY-MM-DD'))
          .forEach(prod => { result += Number(prod.upr_producao) })

        return setResult(result)
      }

      if (period === 'MONTH') {
        let result = 0
        producao
          .filter(prod => {
            const updData = moment(prod.upr_data)
            const startDate = moment().startOf('month')
            const endDate = moment()

            return updData.isBetween(startDate, endDate, 'days', '[]')
          })
          .forEach(prod => { result += Number(prod.upr_producao) })

        return setResult(result)
      }

      if (period === 'YEAR') {
        let result = 0
        producao
          .filter(prod => {
            const updData = moment(prod.upr_data)
            const startDate = moment().startOf('year')
            const endDate = moment()

            return updData.isBetween(startDate, endDate, 'days', '[]')
          })
          .forEach(prod => { result += Number(prod.upr_producao) })

        return setResult(result)
      }
    }
  },
  updated () {
    this.updateData()
  },
  created () {
    this.updateData()
    this.loadContent()
  }
}
</script>

<style lang="scss" scoped>
@import "@scss/_variables.scss";
@import "@scss/_ui.scss";
.item_cards {
  align-items: center;
  border-right: 12px solid;
  border-radius: 0px!important;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
}

>>> .small {
  font-size: 12px !important;
  color: $text;
}
>>> .button_fixed {
  border-radius: 100%;
  // bottom: -2px;
  height: 35px!important;
  min-width: inherit!important;
  // position: absolute;
  // right: -20px;
  width: 35px;
}
.filtros {
  span {
    float: left;
    height: 25px;
    margin-left: 10px;
    width: 25px;
  }
  label {
    float: left;
    margin-left: 8px;
    margin-top: 2px;
  }
  @media (max-width: 767px){
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/cadastros/StatusInversores.vue